import axios from 'axios';
import { isNil } from 'lodash';

export default class CookieConsent {
    private acceptBtn: HTMLAnchorElement;
    private dismissBtn: HTMLAnchorElement;
    private cookieContainer: HTMLElement;

    constructor(cookieContainerID: string, private acceptAllURL: string, private acceptRequiredURL: string) {
        this.cookieContainer = document.getElementById(cookieContainerID);
        if (!this.cookieContainer) return;

        this.initialise();
    }

    private initialise() {
        try {
            // Consent slightly delayed to allow the bootstrap element to initialise
            setTimeout(() => {
                this.dismissBtn = this.cookieContainer.querySelector<HTMLAnchorElement>(".action-dismiss");
                this.acceptBtn = this.cookieContainer.querySelector<HTMLAnchorElement>(".action-accept");
                this.AcceptCookies = this.AcceptCookies.bind(this);
                this.AddEventListeners();

            }, 500);
        }
        catch (err) {
            console.error(err)
        }
    }

    // Adds event listeners to the accept
    private AddEventListeners(): void {
        this.acceptBtn?.addEventListener('click', this.AcceptCookies);
        this.dismissBtn?.addEventListener('click', (e) => this.AcceptCookies(e, 0))
    }

    // Sends a request to the CookiesController, accepting the cookies and creating a Data Protection Consent
    private async AcceptCookies(e: Event, level?: number): Promise<void> {
        e.preventDefault();

        try {
            // Check if the allCookie checkbox is checked, and send api request based on the checkbox status
            const acceptURL = this.cookieContainer.querySelector<HTMLInputElement>("#allCookieCk").checked && isNil(level)
                ? this.acceptAllURL
                : this.acceptRequiredURL;

            await axios.post(acceptURL).then(() => {
                this.cookieContainer.setAttribute("style", "display:none");

                var urlParams = new URLSearchParams(window.location.search);
                if (urlParams?.has('cookiepreference')) {
                    // Remove the reset query from the URL
                    const urlWithoutQuery = window.location.href.replace(/[?&]cookiepreference=true/g, '');
                    window.location.href = urlWithoutQuery;
                }

            }).catch((): void => {
                console.warn("Unable to accept cookie consent at this time.");
                this.cookieContainer.setAttribute("style", "display:none");
            });
        }
        catch (err) {
            console.error(err)
        }
    }
}
